import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import {Button, message, Modal, Radio, Tooltip} from "antd"
import {csvData, csvFBA} from '../../helpers/TemplateImport'
import {CSVLink} from "react-csv"
import {importTrackingDHL, importTrackingFBA} from '../../../../services/api/apiNextBox'

class ImportTrackingModal extends Component {
    state = {
        loading: false,
        visible: false,
        error: '',
        files: '',
        listErrors: [],
        templates: [
            {
                name: 'DHL',
                title: 'Import tracking DHL',
                templateName: 'DHL-tracking-template.csv',
                templateData: csvData,
            },
            {
                name: 'FBA',
                title: 'Import tracking FBA',
                templateName: 'FBA-tracking-template.csv',
                templateData: csvFBA,
            },
        ],
        defaultTemplate: 'DHL',
    }

    componentDidMount() {
        const {templates, defaultTemplate} = this.state
        let {template} = this.state

        if (!template) {
            template = templates.find(tmp => tmp.name === defaultTemplate)

            this.setState({template})
        }
    }

    importTemplateFBA = async () => {
        this.setState({
            loading: true,
            error: '',
        })

        try {
            const {files} = this.state
            const formData = new FormData()

            if (files.length > 0) {
                formData.append('file', files[0])
            }

            const {data: {data: csvRows, success, message}} = await importTrackingFBA(formData)

            this.setState({
                loading: false,
                csvRows,
                error: !success ? message : '',
                files: {},
                imported: true,
            }, () => {
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message,
            })
        }
    }

    _onUpdateImport = async () => {
        const {template} = this.state
        if (template && template.name === 'FBA') {
            return this.importTemplateFBA()
        }

        this.setState({
            loading: true,
            error: '',
        })

        try {
            const {onLoadBox} = this.props
            const {files} = this.state
            const formData = new FormData()

            if (files.length > 0) {
                formData.append('file', files[0])
            }

            const {data: response} = await importTrackingDHL(formData)

            const {success, message: error, data} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: error,
                })
            }

            const {errors} = data

            this.setState({
                loading: false,
                listErrors: errors,
            }, () => {
                this._onCancel()
                const {listErrors} = this.state

                if (listErrors.length > 0) {
                    Modal.error({
                        className: 'ConfirmBox',
                        title: 'Các bản ghi không thành công',
                        content: (
                            <div className="Errors">
                                <ul>
                                    {
                                        !!listErrors && listErrors.length > 0 && listErrors.map((item) => (
                                            <li>
                                                <span>Số thứ tự bản ghi: {parseInt(item.index) + 1}</span>
                                                <span>Lỗi: <span className="text-danger">{item.errors}</span></span>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        ),
                        okText: 'Đóng',
                        onOk() {
                            onLoadBox()
                        },
                    })
                } else {
                    message.success('Import thành công.')
                    onLoadBox()
                }
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message,
            })
        }
    }

    _onShowModal = () => {
        this.setState({
            visible: true,
        })
    }

    resetState = () => {
        const newState = {
            files: {},
            error: '',
            csvRows: [],
            imported: false,
        }

        this.setState(newState)
    }

    _onCancel = () => {
        const newState = {
            visible: false,
            files: {},
            error: '',
            csvRows: [],
            imported: false,
        }

        this.setState(newState)
    }

    _handleChangeFile = (e) => {
        const {files} = e.target
        if (!files || !files[0]) {
            return
        }

        if (files[0].size > 31457280) {
            this.setState({
                error: 'File size is lager than 30M',
            })
        } else {
            this.setState({
                error: '',
                files: files,
                imported: false,
            })
        }
    }

    _onDeleteFile = (index) => {
        const {files} = this.state
        const newFilter = Object.assign({}, files)
        delete newFilter[index]

        this.setState({
            files: newFilter,
        })
    }

    _onChangeFile = (e) => {
        //e.target.value = ''
    }

    _onChangeTemplate = (e) => {
        const {templates} = this.state

        this.setState({
            template: templates.find(tmp => tmp.name === e.target.value),
        })
    }

    showResults = () => {
        const {csvRows, imported} = this.state
        const isError = csvRows ? csvRows.filter(row => row.errors && row.errors.length).length : false

        return imported ? <Fragment>
            <p><strong>Imported results</strong></p>
            {csvRows && !!csvRows.length && <table className="ImportResults table mb-4">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Box Id</th>
                    <th>Carrier</th>
                    <th>Tracking Number/Old Tracking Number</th>
                    <th>Tracking Url</th>
                    <th>Overwrite</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                {
                    csvRows.map(row => {
                        const {
                            index,
                            boxId,
                            overwrite,
                            shippingCarrier,
                            originalCarrier,
                            trackingNumber,
                            trackingUrl,
                            oldTrackingNumber,
                            action,
                            errors,
                        } = row
                        const isRowError = errors && !!errors.length
                        const rowHTML = <tr key={boxId}
                                            className={[isRowError ? 'error' : (!isError && 'success' || '')].join(' ')}>
                            <td>
                                {index + 1}
                            </td>
                            <td>{boxId}</td>
                            <td>{originalCarrier} / {shippingCarrier}</td>
                            <td>
                                <span>{trackingNumber}</span> / <span
                                className="old-tracking">{oldTrackingNumber ? oldTrackingNumber : '-'}</span>
                            </td>
                            <td>{trackingUrl}</td>
                            <td>{overwrite}</td>
                            <td className="action">{action && <i className="fa fa-check"/>}{action || '-'}</td>
                        </tr>

                        return isRowError ?
                            <Tooltip key={boxId} title={errors.join(". ")}>{rowHTML}</Tooltip> : rowHTML
                    })
                }
                </tbody>
            </table>
            }
        </Fragment> : ''
    }

    render() {
        const {loading, visible, files, error, templates, defaultTemplate, imported} = this.state
        const keysFile = Object.keys(files)
        let {template} = this.state

        if (!template) {
            template = templates.find(tmp => tmp.name === defaultTemplate)
        }

        return (
            <div className="ImportTrackingModal">
                <button type="primary" className='btn btn-secondary ml-3' onClick={this._onShowModal}>
                    <i className="fa fa-upload"/>
                    Import tracking
                </button>
                <Modal
                    width="80%"
                    className="ImportModal"
                    visible={visible}
                    title={template && template.title || 'Import tracking'}
                    onOk={this._onUpdateImport}
                    onCancel={this._onCancel}
                    footer={[
                        <Button key="back" onClick={this._onCancel}>
                            <i className="fa fa-times"/>
                            Close
                        </Button>,
                        imported && <Button key="import-other" type="primary" onClick={this.resetState}>
                            <i className="fa fa-plus"/>
                            Import other file
                        </Button> || '',
                        <Button id="doImport" key="submit" type="primary" className={loading ? 'loading' : ''}
                                disabled={!keysFile || !keysFile.length} loading={loading}
                                onClick={this._onUpdateImport}>
                            <i className="fa fa-upload"/>
                            Import
                        </Button>,
                    ]}
                >
                    <div className="ImportTracking">
                        {imported && this.showResults()}

                        {
                            !imported && <Fragment>

                                {
                                    template &&
                                    <Radio.Group onChange={this._onChangeTemplate} value={template.name}>
                                        {
                                            templates.map(temp => {
                                                return <Radio key={temp.name} value={temp.name}>{temp.name}</Radio>

                                            })
                                        }
                                    </Radio.Group>
                                }
                                <div className="AttachFile">
                                    <div className="Template">
                                        {
                                            template && template.templateName && template.templateData &&
                                            <CSVLink
                                                data={template.templateData}
                                                filename={template.templateName}
                                                className="btn btn-link"
                                            >
                                                Download template {template.name}
                                            </CSVLink>
                                        }
                                    </div>

                                    <input
                                        id={`import_select_file`}
                                        type="file"
                                        accept="text/csv"
                                        multiple={false}
                                        onChange={this._handleChangeFile}
                                        onClick={this._onChangeFile}
                                    />
                                    <label htmlFor={`import_select_file`} id={`import_select_file`}
                                           className="d-block mb-0 cursor-pointer">
                                        <i className="fa fa-cloud-upload"/> Attach file
                                    </label>
                                </div>
                                <div className="ListFileInput">
                                    <ul>
                                        {
                                            keysFile && keysFile.length > 0 && keysFile.map((item, index) => (
                                                <li key={index}>
                                                    <div className="Left">
                                                        <i className="fa fa-paperclip"/>
                                                        <span className="FileName">{files[item].name}</span>
                                                    </div>

                                                    <i className="fa fa-trash-o"
                                                       onClick={() => this._onDeleteFile(item)}/>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </Fragment>
                        }
                        {
                            error && error.length > 0 && <div className="text-danger mb-3">{error}</div>
                        }
                    </div>
                </Modal>
            </div>
        )
    }
}

ImportTrackingModal.propTypes = {
    onLoadBox: PropTypes.func.isRequired,
}

export default ImportTrackingModal
